<template>
  <div class="flex flex-col gap-8">
    <h2 class="font-bold text-18">How does it work?</h2>
    <div class="flex gap-6 md:flex-col">
      <div class="grid grid-cols-1 md:grid-cols-4 shrink-0">
        <div class="flex flex-col md:flex-row justify-center items-center">
          <div
            class="rounded-8 w-10 h-10 flex items-center justify-center bg-grayscale-10 border border-grayscale-20"
          >
            <p>1</p>
          </div>
          <span class="w-px md:w-auto md:h-px flex-1 bg-grayscale-20" />
        </div>
        <div class="flex flex-col md:flex-row justify-center items-center">
          <div
            class="rounded-8 w-10 h-10 flex items-center justify-center bg-grayscale-10 border border-grayscale-20"
          >
            <p>2</p>
          </div>
          <span class="w-px md:w-auto md:h-px flex-1 bg-grayscale-20" />
        </div>
        <div class="flex flex-col md:flex-row justify-center items-center">
          <div
            class="rounded-8 w-10 h-10 flex items-center justify-center bg-grayscale-10 border border-grayscale-20"
          >
            <p>3</p>
          </div>
          <span class="w-px md:w-auto md:h-px flex-1 bg-grayscale-20" />
        </div>
        <div class="flex flex-col md:flex-row justify-center items-center">
          <div
            class="rounded-8 w-10 h-10 flex items-center justify-center rocket-color"
          >
            <p>🚀</p>
          </div>
          <span class="w-px md:w-auto md:h-px flex-1" />
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-4">
        <div class="text-14 flex flex-col gap-2 pb-10 md:pb-0 md:pr-8">
          <p class="font-bold">Choose a Service</p>
          <p class="text-grayscale-90">
            1-1 Videos call or an async feedback message
          </p>
        </div>
        <div class="text-14 flex flex-col gap-2 pb-10 md:pb-0 md:pr-8">
          <p class="font-bold">Specify Your Request</p>
          <p class="text-grayscale-90">
            Tell your story, share tracks, ask whatever you like
          </p>
        </div>
        <div class="text-14 flex flex-col gap-2 pb-10 md:pb-0 md:pr-8">
          <p class="font-bold">Pay Safely</p>
          <p class="text-grayscale-90">Secure payment & money back guarantee</p>
        </div>
        <div
          class="text-14 flex flex-col gap-2 pb-10 md:pb-0 md:pr-8 text-accent-green"
        >
          <p class="font-bold">Get Your Music Heard</p>
          <p>Guaranteed to level up your knowledge and skills</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.rocket-color {
  background-color: rgba(154, 255, 86, 0.2);
  border: 1px solid rgba(2, 255, 86, 0.5);
}
</style>
